import { inject, Injectable } from '@angular/core'
import { type HttpInterceptor, type HttpEvent, type HttpRequest, type HttpHandler } from '@angular/common/http'
import { type Observable } from 'rxjs'
import { UserPartnerContextStore } from '@inside-hub-app/hub-user-partner-context'

const DEALER_HEADER = 'X-Dealer-Id'

@Injectable()
export class PpDealerIdInterceptor implements HttpInterceptor {
  private readonly userPartnerContextStore = inject(UserPartnerContextStore)

  intercept (request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const currentDealer = this.userPartnerContextStore.currentPartner()
    if (!currentDealer) {
      return next.handle(request)
    }
    const id = request.headers?.get(DEALER_HEADER) || currentDealer.id.toString()
    const cloneRequest = request.clone({
      setHeaders: {
        [DEALER_HEADER]: id
      }
    })

    return next.handle(cloneRequest)
  }
}
